module.exports = __webpack_public_path__ + "static/media/calendar.1214674b.svg";